'use client';
import { css, styled } from '@mui/material/styles';
export const AlertDescription = styled('div')(({ theme }) => css `
    color: ${theme.tokens.FuelColorTextPrimary};
    font-weight: ${theme.tokens.FuelFontWeightBase};
    font-size: ${theme.tokens.FuelFontSizeBase};
    line-height:  ${theme.tokens.FuelLineHeightBase};
`);
